import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import emitter, { EmitterEventTypes } from '~/lib/emitter';
import { ErrorContext } from '~/lib/ErrorContext';
import * as Toast from '~/lib/Toast';

let apiToken: null | string = null;
export function getToken() {
    return apiToken || localStorage.getItem('client-api-token');
}

export function setToken(token: string) {
    apiToken = token;
    if (!token) {
        localStorage.removeItem('client-api-token');
    } else {
        localStorage.setItem('client-api-token', token);
    }

    console.log('token set');
    emitter.emit(EmitterEventTypes.CLIENT_TOKEN_UPDATED);
}

function clientRoute(route: string) {
    return `/api${route}`;
}

async function getHeaders() {
    const token = getToken();
    if (!token) {
        return {
            Accept: 'application/json',
        };
    }

    return {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
    };
}

export async function get(route: string) {
    const res = await axios.get(clientRoute(route), {
        headers: await getHeaders(),
    });

    return res.data;
}

export async function post(
    route: string,
    data: Parameters<typeof axios.post>[1],
) {
    const res = await axios.post(clientRoute(route), data, {
        headers: await getHeaders(),
    });

    return res.data;
}

export function useClientPostApi(route: string, opts: any) {
    const [isSaving, setIsSaving] = useState(false);
    let res = null;

    function save(data) {
        if (isSaving) {
            return {
                then: () => null,
                catch: () => null,
                finally: () => null,
            };
        }

        setIsSaving(true);

        return post(route, data)
            .catch(err => {
                const message = err.response?.data?.message;
                if (!opts?.noToast) {
                    if (message) {
                        Toast.error(message);
                    } else {
                        Toast.error('Failed to save, please try again');
                    }
                }

                if (err.response?.data?.errors) {
                    if (opts?.onError) opts.onError(err.response?.data?.errors);
                }

                throw err;
            })
            .finally(() => {
                setIsSaving(false);
            });
    }

    return {
        isSaving,
        save,
    };
}
